module.exports = __webpack_public_path__ + "res/24-img_bg.ac450c39e42b570df1cf70038053882d.png";